<gc-modal
  [headerTitle]="
    'sharepointExport.overwriteReportsConfirmationModal.title' | translate
  "
  [headerIcon]="'triangleExclamation'"
  [primaryButtonText]="
    'sharepointExport.overwriteReportsConfirmationModal.confirm' | translate
  "
  [secondaryButtonText]="
    'sharepointExport.overwriteReportsConfirmationModal.cancel' | translate
  "
  [closeOnOutsideClick]="false"
  [showCloseIcon]="false"
  (primaryButtonClicked)="handleOnClickConfirm()"
  (secondaryButtonClicked)="handleOnClickCancel()"
>
  <gc-text [variant]="'largeParagraph'">{{
    'sharepointExport.overwriteReportsConfirmationModal.body' | translate
  }}</gc-text>
</gc-modal>
